import React from 'react'
import styled from 'styled-components'

const Loading = ({ isBack }) => (
  <LoadingLayout>
    <LoadingModal>
      <span>
        <i className="fas fa-spinner fa-pulse" />
      </span>
      <TextLoading className="title">Loading... </TextLoading>
      {isBack && <div className="button is-outlined is-danger"> ย้อนกลับ </div>}
    </LoadingModal>
  </LoadingLayout>
)
const TextLoading = styled.span`
  font-size: 15px;
`

const LoadingModal = styled.div`
  background: #f2f2f2f0;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px;
  font-size: 60px;
  border-radius: 12px;
`

const LoadingLayout = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;

  width: 100vw;
  height: 100vh;
  z-index: 9999;
`
export default Loading



// WEBPACK FOOTER //
// ./src/modules/loader/Loading.js